import React from "react";
import { useNavigate } from "react-router-dom";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import CardsAdminUsuarios from "../../cards/CardsAdminUsuarios";
import BtnAcessoRapido from "../../AcessoRapido/BtnAcessoRapido";
import ListaUsuarios from "../ListaUsuarios/ListaUsuarios";
import Api from "../../Services/Api";
import { useAuth } from "../../auth/AuthContext";
import {
  ACCESS_TYPES,
  isSuperAdmin,
  normalizeAccessType,
} from "../../../utils/accessControl";

const Usuarios = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [menuClose, setMenuClose] = React.useState(false);
  const [usuarios, setUsuarios] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const toggleMenu = () => setMenuClose((prev) => !prev);
  const viewerRole = normalizeAccessType(user?.access_type);
  const superAdmin = isSuperAdmin(viewerRole);

  React.useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        setLoading(true);
        const res = await Api.get("/usuarios");
        setUsuarios(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Erro ao buscar usuarios:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, []);

  const handleEdit = (userId) => {
    navigate(`/adicionarusuarios/${userId}`);
  };

  const handleToggleStatus = async (item) => {
    const statusAtual = String(item?.status || "").toUpperCase();
    const novoStatus = statusAtual === "INACTIVE" ? "ACTIVE" : "INACTIVE";

    try {
      await Api.patch(`/usuarios/${item.id}/status`, { status: novoStatus });

      setUsuarios((prev) =>
        prev.map((u) =>
          Number(u.id) === Number(item.id)
            ? {
                ...u,
                status: novoStatus,
              }
            : u
        )
      );
    } catch (err) {
      const message =
        err?.response?.data?.message || "Nao foi possivel atualizar o status do usuario.";
      throw new Error(message);
    }
  };

  const usuariosVisiveis = React.useMemo(() => {
    if (superAdmin) return usuarios;
    return usuarios.filter(
      (item) => normalizeAccessType(item?.access_type) === ACCESS_TYPES.LICENSED
    );
  }, [superAdmin, usuarios]);

  const usuariosAtivos = usuariosVisiveis.filter(
    (item) => String(item?.status || "").toUpperCase() === "ACTIVE"
  ).length;

  const usuariosInativos = usuariosVisiveis.filter(
    (item) => String(item?.status || "").toUpperCase() === "INACTIVE"
  ).length;

  const totalTitle = superAdmin ? "Total de usuarios" : "Total de licenciados";
  const totalSubtitle = superAdmin
    ? "Contagem geral de usuarios visiveis para o super administrador."
    : "Contagem geral de usuarios licenciados cadastrados no sistema.";
  const statusSubtitle = superAdmin ? "Status de todos os usuarios." : "Status de licenciados.";
  const addButtonText = superAdmin ? "Adicionar usuario" : "Adicionar licenciado";

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} usuariosActive="active" />

      <main className="main-content">
        <Topbar page="Lista de Usuarios" onToggleMenu={toggleMenu} />

        <CardsAdminUsuarios
          total={usuariosVisiveis.length}
          ativos={usuariosAtivos}
          inativos={usuariosInativos}
          totalTitle={totalTitle}
          totalSubtitle={totalSubtitle}
          statusSubtitle={statusSubtitle}
        />

        <BtnAcessoRapido icone="+" text={addButtonText} link="/adicionarusuarios" />

        {loading ? (
          <p>Carregando usuarios...</p>
        ) : (
          <ListaUsuarios
            lista={usuariosVisiveis}
            viewerRole={viewerRole}
            onEdit={handleEdit}
            onToggleStatus={handleToggleStatus}
          />
        )}
      </main>
    </div>
  );
};

export default Usuarios;
